import { sendGet } from './axios';

export const getAllResource = (payload: any) => sendGet(`/common/resource`, payload);
